
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 41","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.667 10.5L5 20a32.131 32.131 0 017.5 4.5 19.48 19.48 0 014.5 6h6a19.48 19.48 0 014.5-6A32.132 32.132 0 0135 20l-1.667-9.5a54.167 54.167 0 01-26.666 0z"}}),_c('path',{attrs:{"d":"M6.667 8.833c.137 0 .275.018.408.052a52.499 52.499 0 0025.848 0 1.667 1.667 0 012.05 1.333l1.667 9.5a1.667 1.667 0 01-1 1.834 30.625 30.625 0 00-7.043 4.215 17.97 17.97 0 00-4.075 5.425 1.667 1.667 0 01-1.522.986h-6a1.667 1.667 0 01-1.523-.99 17.97 17.97 0 00-4.075-5.423 30.623 30.623 0 00-7.045-4.217 1.667 1.667 0 01-1-1.833l1.666-9.5a1.667 1.667 0 011.644-1.382zm13.333 5a62.123 62.123 0 01-12-1.325l-1.142 6.5a31.27 31.27 0 016.734 4.23 21.15 21.15 0 014.423 5.589h3.958a21.145 21.145 0 014.424-5.589 31.27 31.27 0 016.733-4.23l-1.142-6.5A62.122 62.122 0 0120 13.833z"}})])
          )
        }
      }
    